<template>
    <router-view/>
</template>

<script>
    import store from './app/store/index.js'

    export default {
        name: 'App',
        store
    }
</script>

<style lang="scss">
  // Import Main styles for this application
  @import '@/app/assets/styles/bootstrap.scss';
  @import '@/app/assets/styles/app.scss';
  @import '@/app/assets/styles/smartBrain.scss';

</style>

